import React from 'react'
import classNames from 'classnames'
import AspectBox from 'src/components/aspect-box'

const Card = ({ className, children, ...rest }) => {
  const defaultCardWidth = 373.33
  const defaultCardHeight = 539.5
  return (
    <AspectBox
      x={defaultCardWidth}
      y={defaultCardHeight}
      className={classNames('card', className)}
      {...rest}
    >
      {children}
    </AspectBox>
  )
}

export default Card
